const qs = require('qs');

export const PAGE_SIZE = 25;

const DT_COLUMNS = ['name', 'email', 'total_events', 'market', 'lifetime_value', 'last_seen'];
const SEARCHABLE = ['name', 'email'];

export function buildParams(draw, page, search, sort, filters) {
  const columns = {};
  DT_COLUMNS.forEach((data, i) => {
    columns[i] = {
      data,
      searchable: SEARCHABLE.includes(data),
      orderable: true,
      search: { value: '', regex: false },
    };
  });
  const orderColumn = Math.max(0, DT_COLUMNS.indexOf(sort.key));

  const params = {
    draw,
    start: (page - 1) * PAGE_SIZE,
    length: PAGE_SIZE,
    search: { value: search, regex: false },
    columns,
    order: { 0: { column: orderColumn, dir: sort.direction } },
  };

  if (filters.name) params.name_eq = filters.name.value;
  if (filters.email) params.email_eq = filters.email.value;
  if (filters.city) params.geo_city_eq = filters.city.value;
  if (filters.state) params.geo_state_eq = filters.state.value;
  if (filters.tags.length) params.tags = filters.tags.map((tag) => tag.value);

  return params;
}

export function serializeParams(params) {
  return qs.stringify(params, { arrayFormat: 'brackets' });
}

export function buildExportUrl(csvUrl, search, sort, filters) {
  return `${csvUrl}?${serializeParams(buildParams(0, 1, search, sort, filters))}`;
}
